var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivfeatureCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEF7F4",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_681_8351)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_681_8351)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_681_8351)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_681_8351",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0.600098H0V40.6001H40V0.600098Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_681_8351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.8281 38.1783H37.1305L33.9388 31.7949C33.7403 31.3979 33.3345 31.1471 32.8906 31.1471H25.2841L19.8119 14.8154L32.0367 10.7288C32.7366 10.4948 33.05 9.67746 32.6821 9.03504C29.5294 3.52894 23.0448 0.652147 15.7352 2.62324L15.3527 1.47871C15.1475 0.864959 14.4837 0.533475 13.8697 0.738788C13.2559 0.944022 12.9246 1.60793 13.1298 2.22176L13.5124 3.36629C6.49539 6.18371 3.03492 12.3768 3.82836 18.6806C3.92109 19.4171 4.66445 19.8787 5.36266 19.6457L17.5891 15.5586L22.8123 31.1471H11.3936L1.93477 24.3368C1.40945 23.9586 0.677109 24.0778 0.298984 24.603C-0.0792188 25.1282 0.0400781 25.8606 0.565234 26.2388L9.63859 32.7716L7.89641 38.1784H1.17188C0.524687 38.1784 0 38.7031 0 39.3503C0 39.9975 0.524687 40.5221 1.17188 40.5221H38.8281C39.4753 40.5221 40 39.9975 40 39.3503C40 38.7031 39.4753 38.1783 38.8281 38.1783ZM15.3553 5.18465C15.3551 5.18473 15.3555 5.18457 15.3553 5.18465C15.3631 5.18575 16.7474 4.5398 19.2116 6.93418C20.485 8.17144 21.6102 9.8191 22.3487 11.4961L13.5643 14.4327C12.6348 10.4697 13.4205 5.83223 15.3553 5.18465ZM29.8552 8.98684L24.5795 10.7504C23.5683 8.37519 21.8255 5.91941 19.8177 4.35465C23.7927 4.21715 27.4656 5.77105 29.8552 8.98684ZM11.292 7.20434C10.6238 9.67996 10.7191 12.6903 11.3352 15.1779L6.05781 16.9421C6.03383 13.0327 7.94828 9.54387 11.292 7.20434ZM32.1663 33.4908L34.5101 38.1783H27.6401L26.0695 33.4908H32.1663ZM11.8692 33.4908H23.5977L25.1683 38.1783H10.3588L11.8692 33.4908Z",
    fill: "#5CC155"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_681_8351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 41,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_681_8351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 41,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_681_8351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 41,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivfeatureCardIcon);
export default __webpack_public_path__ + "static/media/div.featureCard__icon.80869313913d280c071ee75e1aed9431.svg";
export { ForwardRef as ReactComponent };